module.exports = __webpack_public_path__ + "static/media/header-back-white.8326befe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/icons/header-back-white.svg
// module id = 796
// module chunks = 0